<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" v-bind="$attrs">
        {{ btnText }}
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="title">
        {{ modalTitle }}
      </v-card-title>

      <v-card-text>
        <v-divider class="pb-6"></v-divider>

        <slot name="form" :cancel="closeModal"></slot>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ProjectCreateModal',
  props: {
    btnText: {
      type: String,
      required: true
    },
    modalTitle: {
      type: String,
      required: true
    }
  },
  data: () => ({
    dialog: false
  }),
  methods: {
    closeModal() {
      this.dialog = false
    }
  }
}
</script>
